import React from 'react';
import { useTranslation } from 'react-i18next';
import useDashboardStore from '../../stores/dashboardStore';

// Usage:
// <ProfileCompletion
//     completionFields={completionFields}
//     improvementFields={improvementFields}
//     allFieldsDone={allFieldsDone}
//     allImprovementsDone={allImprovementsDone}
//     showCompletionBlock={showCompletionBlock}
//     onConnectTelegram={handleConnectTelegram}
// />

const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);

const EmptyBox = () => (
    <div style={{ width: '20px', height: '20px', border: '2px solid #e5e7eb', borderRadius: '4px', flexShrink: 0 }}></div>
);

const ProfileCompletion = ({
    completionFields,
    improvementFields,
    allFieldsDone,
    allImprovementsDone,
    showCompletionBlock,
}) => {
    const { t } = useTranslation();

    const user = useDashboardStore(s => s.user);
    const showCompletionSuccess = useDashboardStore(s => s.showCompletionSuccess);
    const setIsEditMode = useDashboardStore(s => s.setIsEditMode);
    const isEditMode = useDashboardStore(s => s.isEditMode);

    return (
        <>
            {/* Part A: Profile Completion Block */}
            {showCompletionBlock && (
                <div className="glass-card" style={{ padding: '1.5rem', marginBottom: '1.5rem', animation: 'fadeIn 0.5s ease-out' }}>
                    {showCompletionSuccess ? (
                        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                            <h3 style={{ color: '#10b981', fontSize: '1.25rem', marginBottom: '0.5rem' }}>{t('dashboard.profile.ready', 'Yes! Your profile is ready!')}</h3>
                            <div style={{ fontSize: '3rem' }}>🎉</div>
                        </div>
                    ) : (
                        <>
                            <h2 className="section-title" style={{ marginBottom: '1rem', fontSize: '1.25rem' }}>
                                {t('dashboard.profile.complete_profile', 'Complete the profile')}
                            </h2>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                {completionFields.map(field => (
                                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.95rem' }}>
                                        {field.done ? <CheckIcon /> : <EmptyBox />}
                                        <span style={{ color: field.done ? '#1f2937' : '#6b7280', textDecoration: field.done ? 'none' : 'none' }}>
                                            {field.label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}

            {/* Part B: Improvement Block */}
            {allFieldsDone && !allImprovementsDone && (
                <div className="glass-card" style={{ padding: '1.5rem', marginTop: '1.5rem', marginBottom: '1.5rem', animation: 'fadeIn 0.5s ease-out' }}>
                    <h2 className="section-title" style={{ marginBottom: '1rem', fontSize: '1.25rem' }}>
                        {t('dashboard.profile.improve_profile', 'Improve your profile')}
                    </h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                        {improvementFields.map(field => (
                            <div
                                key={field.key}
                                style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.95rem', cursor: 'pointer' }}
                                onClick={() => {
                                    if (!isEditMode) setIsEditMode(true);
                                }}
                            >
                                {field.done ? <CheckIcon /> : <EmptyBox />}
                                <span style={{ color: field.done ? '#1f2937' : '#6b7280' }}>
                                    {field.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ProfileCompletion;
